import React from 'react';
import style from './style';
import clsx from "clsx";

const FicheContextHeaderNavigation = ({previous, next, currentCount, totalCount, additionalClass}) => {
  const {classes} = style();

  return <div className={clsx(classes.navigationContainer, additionalClass)}>
    <div className={classes.counter}>
      {currentCount + 1}/{totalCount}
    </div>
    <div className={classes.navigation}>
      <div
        onClick={previous}
        className={clsx(classes.previous, classes.navigationArrow)}
      >
        <img
          src={process.env.PUBLIC_URL + "/img/icons/arrow/arrow-breadcrumb.svg"}
          alt="<"
        />
      </div>
      <div
        onClick={next}
        className={clsx(classes.next, classes.navigationArrow)}
      >
        <img
          src={process.env.PUBLIC_URL + "/img/icons/arrow/arrow-breadcrumb.svg"}
          alt=">"
        />
      </div>
    </div>
  </div>
}

export default FicheContextHeaderNavigation